const GA_ID = "G-07CV4SGGWN";

let scriptPromise = null;

function ensureStub() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function getCookieConsent() {
  try {
    const m = document.cookie.match(/(?:^|; )cookie-consent=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : "";
  } catch {
    return "";
  }
}

export function loadGtagScript() {
  ensureStub();
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    return Promise.resolve();
  }
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("gtag load failed"));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/** Run once on app boot: stub + consent defaults, defer network until idle (unless declined). */
export function initGtagDeferred() {
  ensureStub();
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    functionality_storage: "denied",
    ad_storage: "denied",
    wait_for_update: 500,
  });

  const schedule =
    typeof requestIdleCallback === "function"
      ? (cb) => requestIdleCallback(cb, { timeout: 4000 })
      : (cb) => setTimeout(cb, 2500);

  schedule(async () => {
    const consent = getCookieConsent();
    if (consent === "declined") return;
    try {
      await loadGtagScript();
      window.gtag("js", new Date());
      if (consent === "accepted") {
        window.gtag("consent", "update", {
          analytics_storage: "granted",
          functionality_storage: "granted",
        });
        window.gtag("config", GA_ID);
      } else {
        window.gtag("config", GA_ID, { anonymize_ip: true });
      }
    } catch {
      /* ignore */
    }
  });
}

export async function grantGtagConsent() {
  ensureStub();
  try {
    await loadGtagScript();
    window.gtag("js", new Date());
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      functionality_storage: "granted",
    });
    window.gtag("config", GA_ID);
  } catch {
    /* ignore */
  }
}

export function denyGtagConsent() {
  ensureStub();
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: "denied",
    functionality_storage: "denied",
  });
}
